import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { CreateUserResult } from '../models/createUserResult';
import { AuthService } from '../services/auth.service';

@Injectable()
export class EnrollmentService {
  private hostPath: string = JSON.parse(environment.IDENTITY);

  constructor(
    private authHttp: HttpClient,
    public router: Router,
    public authService: AuthService
  ) { }

  public createUser(
    email: string,
    firstname: string,
    lastname: string,
    language: string,
    organizationId?: string,
    targetOrganizationId?: string,
    mobile?: string,
    smsVerification?: boolean,
    targetMembershipType?: number
  ): Observable<CreateUserResult> {
    const data = {
      site: 'www.shuttlebuss.se',
      email,
      firstname,
      lastname,
      language,
      organizationId,
      targetOrganizationId,
      mobile,
      smsVerification,
      targetMembershipType
    };
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.authHttp
      .post(this.hostPath + 'identity/User/createuser', data, { headers })
      .pipe(
        map((response: any) => {
          const createUserResult = new CreateUserResult();
          createUserResult.success = response;
          // createUserResult.userId = response;
          return createUserResult;
        }),
        catchError((error: any) => {
          console.log(error);
          const createUserResult = new CreateUserResult();
          const result = error.json();
          createUserResult.success = result.success;
          return observableThrowError(createUserResult);
        })
      );
  }
}
